module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "title"
  }, [_vm._v("О компании")]), _vm._v(" "), _c('template', {
    slot: "section"
  }, [_c('columns', [_c('column', {
    attrs: {
      "size": "10"
    }
  }, [_c('p', [_vm._v("АРК-ЭнергоСбыт – независимая энергостбытовая компания, объединившая высококвалифицированных специалистов с многолетним опытом работы в ведущих энергетических компаниях России.")]), _vm._v(" "), _c('p', [_vm._v("Основным направлением деятельности компании является надёжная и бесперебойная поставка электроэнергии с учётом индивидуальных потребностей клиентов.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Преимущественные условия энергоснабжения:")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("снижение стоимости электрической энергии для потребителя")]), _vm._v(" "), _c('li', [_vm._v("оптимизация поставки электрорэнергии")]), _vm._v(" "), _c('li', [_vm._v("установка и обслуживание автоматизированных систем коммерческого учета электроэнергии (АИИС КУЭ)")]), _vm._v(" "), _c('li', [_vm._v("энерготрейдинг и сопровождение оптового рынка электроэнергии для действующих участников")]), _vm._v(" "), _c('li', [_vm._v("прозрачное ценообразование и гибкая система платежей")]), _vm._v(" "), _c('li', [_vm._v("обеспечение возможности точного планирования потребителем затрат на энергоресурсы")]), _vm._v(" "), _c('li', [_vm._v("клиентоориентированный индивидуальный подход")]), _vm._v(" "), _c('li', [_vm._v("обеспечение надежности поставки")]), _vm._v(" "), _c('li', [_vm._v("комплексное юридическое сопровождение и обеспечение безопасности")])])])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.showSecondBg) ? _c('aside-image', {
    key: _vm.showSecondBg,
    attrs: {
      "image": _vm.imageBg2
    }
  }) : _c('aside-image', {
    key: _vm.showSecondBg,
    attrs: {
      "image": _vm.imageBg
    }
  })], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fc0e410"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 125
// module chunks = 0